import { useAccount } from "wagmi"

export function useConnector() {
  const { connector } = useAccount()

  return {
    isWalletConnect: connector && connector.id === "walletConnect",
  }
}
